"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LinkForm_1 = require("./Form/LinkForm");
const react_1 = __importDefault(require("react"));
const react_2 = require("@remirror/react");
const InsertLinkRounded_1 = __importDefault(require("@mui/icons-material/InsertLinkRounded"));
const FormModal_1 = __importDefault(require("../../../ui/Modal/FormModal"));
const hooks_1 = require("../../../hooks");
const Extensions_1 = require("../../../Extensions/Extensions");
const LinkModal = ({ onCancel, onSubmit }) => {
    const { helpers, view: { state }, } = (0, react_2.useRemirrorContext)();
    const { selection, marks } = (0, hooks_1.useExpandedSelection)([Extensions_1.MarkName.Link, Extensions_1.MarkName.AssetLink]);
    const selectedText = helpers.getTextBetween(selection.from, selection.to, state.doc);
    const data = {
        linkType: marks[0]?.type?.name === Extensions_1.MarkName.Link ? Extensions_1.MarkName.Link : Extensions_1.MarkName.AssetLink,
        text: selectedText,
        link: { ...marks.find((mark) => mark.type.name === 'link')?.attrs },
        assetLink: { ...marks.find((mark) => mark.type.name === Extensions_1.MarkName.AssetLink)?.attrs },
        range: { from: selection.from, to: selection.to },
    };
    return (react_1.default.createElement(FormModal_1.default, { title: "Link", icon: react_1.default.createElement(InsertLinkRounded_1.default, null), onCancel: onCancel },
        react_1.default.createElement(LinkForm_1.LinkForm, { data: data, onSubmit: onSubmit })));
};
exports.default = LinkModal;
